import React from 'react'
import Loader from '../components/loaders/loader.component'
import Browser from '../services/Browser'
import PropTypes from 'prop-types'
import SiteFooter from '../components/layout/site-footer.component'
import SiteHeader from '../components/layout/site-header.component'
import StyledLayout from './styled-layout.style'
import TripSearchBar from '../components/trip-search-bar/trip-search-bar.component'
import { connect } from 'react-redux'

/**
 *
 * @class SiteLayoutComponent
 * @extends {Component}
 * @param {boolean} noPadding
 * Set the header's padding-top to 0
 *
 * @param {boolean} adaptHeaderBG
 * Set the header's background to change from transparent to white on scroll
 */
class SiteLayoutComponent extends React.Component {
	constructor(props) {
		super(props)
		this.children = props.children
		this.state = {
			isTransparent: true
		}
	}

	handleScroll() {
		if (this.isUnmounted) return

		const { isTransparent } = this.state
		const getScrollY = () =>
			Browser.isIE() ? window.pageYOffset : window.scrollY

		if (!isTransparent && !getScrollY())
			this.setState({ isTransparent: true })
		else if (isTransparent && getScrollY())
			this.setState({ isTransparent: false })
	}

	componentDidMount() {
		this.props.adaptHeaderBG &&
			window.addEventListener('scroll', this.handleScroll.bind(this))
	}

	componentWillUnmount() {
		this.isUnmounted = true
		this.props.adaptHeaderBG &&
			window.removeEventListener('scroll', this.handleScroll.bind(this))
	}

	render() {
		const { loading, noPadding, rendered, user } = this.props
		const { isTransparent } = this.state
		return (
			<StyledLayout noPadding={noPadding}>
				<SiteHeader transparent={isTransparent ? true : false} />
				<TripSearchBar top={10} />
				<div className="body">{this.children}</div>
				<Loader showLoader={loading} transparent />
				{rendered ? <SiteFooter user={user} /> : null}
				<span style={{ visibility: 'hidden' }}>
					Build em: {process.env.BUILD_DATE}
				</span>
			</StyledLayout>
		)
	}
}

SiteLayoutComponent.propTypes = {
	noPadding: PropTypes.bool,
	adaptHeaderBG: PropTypes.bool
}

const mapStoreToProps = store => {
	const { site, user } = store
	return {
		rendered: site.rendered,
		loading: site.loading,
		user
	}
}

const connectedSiteLayout = connect(mapStoreToProps)(SiteLayoutComponent)
export { connectedSiteLayout as SiteLayout }
